





































































import Vue from 'vue'
import Modal from '@/components/Modal'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import './AddEditTeamGroup.scss'
import { cloneDeep, isEmpty, sortBy } from 'lodash'
import { TeamGroup } from '@/types/teams'
import { UserProfile, UserOption } from '@/types/users'
import { Option, Select } from 'element-ui'

enum ModalMode {
  Edit = 'edit',
  Create = 'create',
  ReadOnly = 'read_only'
}

//Templated off of AddEditTeamRole component
export default Vue.extend({
  name: 'AddEditTeamGroup',
  props: {
    teamGroup: {
      type: Object as () => TeamGroup,
      required: true
    },
    groupMembers: {
      type: Array as () => UserProfile[],
      required: false,
      default: () => [] as UserProfile[]
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modalTitle (): string {
      switch (this.mode) {
        case ModalMode.ReadOnly:
          return 'View standard Group'
        case ModalMode.Create:
          return 'Create a new Member Group'
        case ModalMode.Edit:
        default:
          return 'Edit Member Group'
      }
    },
    modalSubmitButtonText (): string {
      return this.readOnly ? 'Close' : 'Submit'
    },
    membersList () {
      const memberNames: string[] = []
      this.groupMembers.forEach(member => {
        memberNames.push(this.getUserDisplayName(member))
      })
      return isEmpty(memberNames) ? 'None' : sortBy(memberNames, name => name.toLowerCase()).join('<br/>') 
    },
    memberUserOptions (): UserOption[] {
      //Identify all users for dropdown options
      let memberUsers: UserOption[] = []
      for (const userId of Object.keys(this.$store.direct.state.team.team.members ?? [])) {
        //Pull user info for dropdown label and value
        const userProfile = this.$store.direct.state.team.currentTeam.find(user => user.id === userId)
        //Only add to options if user found
        if (userProfile) {
          const userOption = { name: '', id: userId }
          userOption.name = this.getUserDisplayName(userProfile)
          memberUsers.push(userOption)
        }
      }
      memberUsers = sortBy(memberUsers, member => member.name.toLowerCase())
      return memberUsers
    },
  },
  data () {
    return {
      submitStatus: '',
      mode: ModalMode.Edit,
      localTeamGroup: cloneDeep(this.teamGroup)
    }
  },
  validations: {
    localTeamGroup: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(256)
      },
      description: {
        maxLength: maxLength(256)
      }
    }
  },
  created () {
    if (this.readOnly) {
      this.mode = ModalMode.ReadOnly
    } else {
      this.mode = this.localTeamGroup.name === '' ? ModalMode.Create : ModalMode.Edit
      if (!this.localTeamGroup.members) this.localTeamGroup.members = []
    }
  },
  methods: {
    formSubmitted (): void {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        this.$emit('addEditDone', this.localTeamGroup)
      }
    },
    hideModal (): void {
      this.$emit('closeModal')
    },
    checkFakeDisable (evt: InputEvent): void {
      if (this.readOnly)
        evt.preventDefault()
    },
    getUserDisplayName (user: UserProfile): string {
      //Return display name by availability in order of preference:
      //DisplayName, FirstName + LastName, FirstName, LastName
      let name = ''
      if (user.display_name) name = user.display_name
      else if (user.first_name && user.last_name) name = user.first_name + ' ' + user.last_name
      else if (user.first_name) name = user.first_name
      else if (user.last_name) name = user.last_name
      else name = 'N/A'
      return name
    }
  },
  watch: {
    groupMembers: {
      immediate: true,
      handler (newMembers) {
        this.localTeamGroup.members = newMembers.map(member => member.id)
      }
    }
  },
  components: {
    Modal,
    'el-select': Select,
    'el-option': Option,
  }
})
